import { EFormStatus } from 'shared/common/types/form';
import { TApplicationState } from 'shared/common/types/redux';

export const selectFormStatus = (state: TApplicationState): EFormStatus => {
  return state.formStatus.status;
};
